import React from 'react';
import { generateRowKey } from '../utils';
import { FooterCell } from './FooterCell';
export function FooterRow({ footerRow, columns }) {
    return (React.createElement("tr", { key: generateRowKey(footerRow, columns) }, columns.map((column) => (React.createElement(FooterCell, { footerRow: footerRow, column: column })))));
}
